const fiscalDataGateDictES = {
  fiscalGateTitle: "Complete sus datos fiscales",
  fiscalGateDescription:
    "Para seguir usando la plataforma y permitirnos emitir automáticamente su factura electrónica, necesitamos que complete sus datos fiscales.",
  personType: "Tipo de persona",
  personTypePhysical: "Persona física",
  personTypeLegal: "Persona jurídica",
  nomeFiscal: "Razón social",
  fiscalDocumentNumber: "Documento fiscal (Codice Fiscale o Partita IVA)",
  fiscalDocumentNumberCPF: "CPF",
  fiscalDocumentNumberCNPJ: "CNPJ",
  fiscalDocumentNumberCodiceFiscale: "Codice Fiscale",
  fiscalDocumentNumberPartitaIVA: "Partita IVA",
  fiscalAddress: "Dirección",
  fiscalGateUnexpectedError: "Error inesperado al guardar sus datos fiscales.",
  fiscalGateSuccess: "Datos fiscales guardados con éxito.",
};

export default fiscalDataGateDictES;
